import { Icon } from '@iconify/react';
import { Modal, Button, Form } from 'react-bootstrap';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Swal from "sweetalert2";
import { Link } from 'react-router-dom';
import { API_URL } from '../../api/api';

const ManageFollowUpLayer = () => {
    const [followUps, setFollowUps] = useState([]);
    const [showAddModal, setShowAddModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showEnquiryModal, setShowEnquiryModal] = useState(false);
    const [enquiryDetails, setEnquiryDetails] = useState(null); // Store the enquiry details

    const [formData, setFormData] = useState({
        customer_name: '',
        follow_up_date: '',
        status: 'Pending',
        notes: '',
        enquiry_id: '',
    });
    const [editFollowUpId, setEditFollowUpId] = useState(null);
    const [errors, setErrors] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 5;
    const [enquiries, setEnquiries] = useState([]);
    const [filterStatus, setFilterStatus] = useState('');
    const [filterCustomerName, setFilterCustomerName] = useState('');

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (token) {
            axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        }
        fetchFollowUps();
        fetchEnquiries();
    }, []);

    const fetchFollowUps = async () => {
        try {
            const response = await axios.get(`${API_URL}/follow-ups`);
            const sortedData = response.data.sort((a, b) => new Date(b.follow_up_date) - new Date(a.follow_up_date));
            setFollowUps(sortedData);
        } catch (error) {
            console.error('Error fetching follow-ups:', error);
        }
    };

    const fetchEnquiries = async () => {
        try {
            const response = await axios.get(`${API_URL}/adminenquiries`);
            setEnquiries(response.data?.data || []);
        } catch (error) {
            console.error('Error fetching enquiries:', error);
        }
    };

    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        if (name === 'status') {
            setFilterStatus(value);
        } else if (name === 'customer_name') {
            setFilterCustomerName(value);
        }
    };

    const filteredFollowUps = followUps.filter(followUp => {
        const matchesStatus = filterStatus ? followUp.status === filterStatus : true;
        const matchesCustomerName = followUp.customer_name && followUp.customer_name.toLowerCase().includes(filterCustomerName.toLowerCase());
        return matchesStatus && matchesCustomerName;
    });


    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentFollowUps = filteredFollowUps.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(filteredFollowUps.length / itemsPerPage);

    const handlePageChange = async (page) => {
        setCurrentPage(page);
    };

    const handleShowEnquiryFollowUp = (followUp) => {
        setEnquiryDetails(followUp.enquiry);  // Directly use the enquiry from followUp
        setShowEnquiryModal(true);
    };

    const handleCloseEnquiryModal = () => {
        setShowEnquiryModal(false);
        setEnquiryDetails(null); // Clear enquiry details
    };

    const openEditModal = (followUp) => {
        setEditFollowUpId(followUp.id);
        setFormData({
            customer_name: followUp.customer_name || '',
            follow_up_date: followUp.follow_up_date || '',
            status: followUp.status || 'Pending',
            notes: followUp.notes || '',
            enquiry_id: followUp.enquiry_id || '',  // Add enquiry_id in edit
        });
        setShowEditModal(true);
    };

    const handleDeleteFollowUp = async (id) => {
        try {
            await axios.delete(`${API_URL}/follow-ups/${id}`);
            setFollowUps(followUps.filter(f => f.id !== id));
        } catch (error) {
            console.error('Error deleting follow-up:', error);
        }
    };
    const handleEditFollowUp = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.put(`${API_URL}/follow-ups/${editFollowUpId}`, formData);
            setFollowUps(followUps.map(f => (f.id === editFollowUpId ? response.data : f)));
            setShowEditModal(false);
            setFormData({ customer_name: '', follow_up_date: '', status: 'Pending', notes: '', enquiry_id: '' });
            setErrors({});
        } catch (error) {
            if (error.response?.data.errors) {
                setErrors(error.response.data.errors);
            } else {
                console.error('Error editing follow-up:', error);
            }
        }
    };
    const handleAddFollowUp = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.post(`${API_URL}/follow-ups`, formData);
            setFollowUps([response.data, ...followUps]);
            setShowAddModal(false);
            setFormData({ customer_name: '', follow_up_date: '', status: 'Pending', notes: '', enquiry_id: '' });
            setErrors({});
        } catch (error) {
            if (error.response?.data.errors) {
                setErrors(error.response.data.errors);
            } else {
                console.error('Error:', error);
            }
        }
    };

    return (
        <div className="card">
            <div className="card-header d-flex flex-wrap align-items-center justify-content-between gap-3">
                <div className="d-flex flex-wrap align-items-center gap-3">
                    <input
                        type="text"
                        className="form-control form-control-sm"
                        placeholder="Search Customer"
                        name="customer_name"
                        value={filterCustomerName}
                        onChange={handleFilterChange}
                    />
                </div>
                <div className="d-flex flex-wrap align-items-center gap-3">
                    <select
                        name="status"
                        className="form-select form-select-sm w-auto"
                        value={filterStatus}
                        onChange={handleFilterChange}
                    >
                        <option value="">All Status</option>
                        <option value="Pending">Pending</option>
                        <option value="Completed">Completed</option>
                        <option value="Cancelled">Cancelled</option>
                    </select>
                    <Link onClick={() => setShowAddModal(true)} className="btn btn-sm btn-primary-600">
                        <i className="ri-add-line" /> Add FollowUp
                    </Link>
                </div>
            </div>

            <div className="card-body">
                <table className="table table-bordered mb-0">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Franchise</th>
                            <th>Customer Name</th>
                            <th>Follow-Up Date</th>
                            <th>Status</th>
                            <th>Notes</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {currentFollowUps.map((followUp, index) => (
                            <tr key={followUp.id}>
                                <td>{indexOfFirstItem + index + 1}</td>
                                <td>{followUp.enquiry?.branch?.centre_name || 'N/A'}</td>
                                <td>{followUp.customer_name}</td>
                                <td>{followUp.follow_up_date}</td>
                                <td>{followUp.status}</td>
                                <td>{followUp.notes}</td>
                                <td>
                                    {(followUp.enquiry?.branch?.centre_name || followUp.enquiry?.branch?.id) && (
                                        <Link
                                            variant="info"
                                            onClick={() => handleShowEnquiryFollowUp(followUp)}  // Pass the full followUp object
                                            className="bg-info-focus text-info-600 w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                                        >
                                            <Icon icon="majesticons:eye-line" className="icon text-xl" />
                                        </Link>
                                    )}

                                    <Button variant="warning" onClick={() => openEditModal(followUp)} className="me-2">
                                        <Icon icon="lucide:edit" />
                                    </Button>
                                    <Button
                                        variant="danger"
                                        onClick={() => {
                                            Swal.fire({
                                                title: 'Are you sure?',
                                                text: 'You will not be able to recover this follow-up!',
                                                icon: 'warning',
                                                showCancelButton: true,
                                                confirmButtonText: 'Yes, delete it!',
                                                cancelButtonText: 'Cancel',
                                            }).then((result) => {
                                                if (result.isConfirmed) {
                                                    handleDeleteFollowUp(followUp.id);
                                                    Swal.fire('Deleted!', 'The follow-up has been deleted.', 'success');
                                                }
                                            });
                                        }}
                                    >
                                        <Icon icon="mingcute:delete-2-line" />
                                    </Button>

                                    {/* Other buttons for edit and delete */}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>

                {/* Pagination */}
                <div className="d-flex justify-content-center mt-3">
                    <nav>
                        <ul className="pagination pagination-sm">
                            {Array.from({ length: totalPages }, (_, i) => i + 1).map(page => (
                                <li key={page} className={`page-item ${page === currentPage ? 'active' : ''}`}>
                                    <button className="page-link" onClick={() => handlePageChange(page)}>
                                        {page}
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </nav>
                </div>
            </div>

            {/* Show Enquiry Follow-Up Modal */}
            <Modal show={showEnquiryModal} onHide={handleCloseEnquiryModal}>
                <Modal.Header closeButton>
                    <Modal.Title>Enquiry Follow-Up Details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {enquiryDetails ? (
                        <div>
                            <h5>Customer Name: {enquiryDetails.name}</h5>
                            <p>Email: {enquiryDetails.email}</p>
                            <p>Phone: {enquiryDetails.phone}</p>
                            <p>Message: {enquiryDetails.message}</p>
                            <p>Status: {enquiryDetails.status}</p>
                            <p>Branch: {enquiryDetails.branch.centre_name}</p>
                            <p>Branch Address: {enquiryDetails.branch.address}</p>
                        </div>
                    ) : (
                        <p>Loading enquiry details...</p>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseEnquiryModal}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Add Follow-Up Modal */}
            <Modal show={showAddModal} onHide={() => setShowAddModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Add Follow-Up</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleAddFollowUp}>
                        <Form.Group className="mb-3">
                            <Form.Label>Customer Name</Form.Label>
                            <Form.Control
                                type="text"
                                value={formData.customer_name}
                                onChange={(e) => setFormData({ ...formData, customer_name: e.target.value })}
                                isInvalid={!!errors.customer_name}
                            />
                            <Form.Control.Feedback type="invalid">{errors.customer_name}</Form.Control.Feedback>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Follow-Up Date</Form.Label>
                            <Form.Control
                                type="date"
                                value={formData.follow_up_date}
                                onChange={(e) => setFormData({ ...formData, follow_up_date: e.target.value })}
                                isInvalid={!!errors.follow_up_date}
                            />
                            <Form.Control.Feedback type="invalid">{errors.follow_up_date}</Form.Control.Feedback>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Status</Form.Label>
                            <Form.Select
                                value={formData.status}
                                onChange={(e) => setFormData({ ...formData, status: e.target.value })}
                            >
                                <option value="Pending">Pending</option>
                                <option value="Completed">Completed</option>
                                <option value="Cancelled">Cancelled</option>
                            </Form.Select>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Notes</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={3}
                                value={formData.notes}
                                onChange={(e) => setFormData({ ...formData, notes: e.target.value })}
                                isInvalid={!!errors.notes}
                            />
                            <Form.Control.Feedback type="invalid">{errors.notes}</Form.Control.Feedback>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Related Enquiry</Form.Label>
                            <Form.Select
                                value={formData.enquiry_id}
                                onChange={(e) => setFormData({ ...formData, enquiry_id: e.target.value })}
                                isInvalid={!!errors.enquiry_id}
                            >
                                <option value="">-- Select Enquiry --</option>
                                {enquiries.map((enquiry) => (
                                    <option key={enquiry.id} value={enquiry.id}>
                                        {enquiry.name}
                                    </option>
                                ))}
                            </Form.Select>
                            <Form.Control.Feedback type="invalid">{errors.enquiry_id}</Form.Control.Feedback>
                        </Form.Group>

                        <Button variant="primary" type="submit">
                            Submit
                        </Button>
                    </Form>
                </Modal.Body>
            </Modal>

            {/* Edit Follow-Up Modal */}
            <Modal show={showEditModal} onHide={() => setShowEditModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Edit Follow-Up</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleEditFollowUp}>
                        <Form.Group className="mb-3">
                            <Form.Label>Customer Name</Form.Label>
                            <Form.Control
                                type="text"
                                value={formData.customer_name}
                                onChange={(e) => setFormData({ ...formData, customer_name: e.target.value })}
                                isInvalid={!!errors.customer_name}
                            />
                            <Form.Control.Feedback type="invalid">{errors.customer_name}</Form.Control.Feedback>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Follow-Up Date</Form.Label>
                            <Form.Control
                                type="date"
                                value={formData.follow_up_date}
                                onChange={(e) => setFormData({ ...formData, follow_up_date: e.target.value })}
                                isInvalid={!!errors.follow_up_date}
                            />
                            <Form.Control.Feedback type="invalid">{errors.follow_up_date}</Form.Control.Feedback>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Status</Form.Label>
                            <Form.Select
                                value={formData.status}
                                onChange={(e) => setFormData({ ...formData, status: e.target.value })}
                            >
                                <option value="Pending">Pending</option>
                                <option value="Completed">Completed</option>
                                <option value="Cancelled">Cancelled</option>
                            </Form.Select>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Notes</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={3}
                                value={formData.notes}
                                onChange={(e) => setFormData({ ...formData, notes: e.target.value })}
                                isInvalid={!!errors.notes}
                            />
                            <Form.Control.Feedback type="invalid">{errors.notes}</Form.Control.Feedback>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Related Enquiry</Form.Label>
                            <Form.Select
                                value={formData.enquiry_id}
                                onChange={(e) => setFormData({ ...formData, enquiry_id: e.target.value })}
                                isInvalid={!!errors.enquiry_id}
                            >
                                <option value="">-- Select Enquiry --</option>
                                {enquiries.map((enquiry) => (
                                    <option key={enquiry.id} value={enquiry.id}>
                                        {enquiry.name}
                                    </option>
                                ))}
                            </Form.Select>
                            <Form.Control.Feedback type="invalid">{errors.enquiry_id}</Form.Control.Feedback>
                        </Form.Group>

                        <Button variant="primary" type="submit">
                            Save Changes
                        </Button>
                    </Form>
                </Modal.Body>
            </Modal>

        </div>
    );
};


export default ManageFollowUpLayer;
